import { InfiniteData, useQueryClient } from '@tanstack/react-query'
import { cloneDeep } from 'lodash'

import { defaultFeedPageParams, GET_FEEDS_API_INFINITE_UNIQUE_KEY, GET_FEEDS_API_UNIQUE_KEY } from './useEntityFeed'
import { Feed, FeedItem } from '../domain/feed'
import { Entity } from '../hooks'

export type SocketData = {
  payload: unknown
  id: string
  domainEventType: string
}

export const useOnFeedActivityUpdate = (entities: Entity[]): ((newActivity: FeedItem) => void) => {
  const queryClient = useQueryClient()

  const onFeedActivityUpdate = (newActivity: FeedItem) => {
    const infiniteQueryKey = [
      GET_FEEDS_API_INFINITE_UNIQUE_KEY,
      { entityID: entities.map((entity) => entity.id), pageSize: 20 },
    ]
    const queryKey = [
      GET_FEEDS_API_UNIQUE_KEY,
      { ...defaultFeedPageParams, entityID: [newActivity.feedInfo.entityID], pageSize: 1, orderBy: '_id' },
    ]
    const feedListInfiniteQueryData: InfiniteData<Feed> | undefined = queryClient.getQueryData(infiniteQueryKey)
    const feedListDataInfiniteCloned = cloneDeep(feedListInfiniteQueryData)
    if ((feedListDataInfiniteCloned?.pages || []).length > 0) {
      const feedDataFirstPage = feedListDataInfiniteCloned?.pages?.[0]
      const activityType = newActivity.activity.type

      if (feedDataFirstPage?.activityCountByType) {
        const activityCount = feedDataFirstPage.activityCountByType[activityType]
        if (activityCount) {
          feedDataFirstPage.activityCountByType[activityType] = activityCount + 1
        } else {
          // create activity object when no items available for specific activity type
          feedDataFirstPage.activityCountByType[activityType] = 1
        }
      }

      feedDataFirstPage?.results?.unshift(newActivity)
      // Updates activity feed
      queryClient.setQueryData(infiniteQueryKey, feedListDataInfiniteCloned)
      // Refreshes query to highlight "New" activity
      queryClient.invalidateQueries({ queryKey: queryKey })
    }
  }
  return onFeedActivityUpdate
}
